import { createApp } from 'vue';
import ZipToIsoConverter from '@/Components/ZipToIsoConverter.vue';
import '@styles/app.css';

createApp(ZipToIsoConverter).mount('#zip-to-iso-converter');
